<adf-layout-header *ngIf="aldenService.showHeader$ | async" [logo]="logo$ | async" [tooltip]="appName$ | async"
  [color]="headerColor$ | async" [title]="showTitleHeader ? (appName$ | async) : ''"
  (clicked)="toggleClicked.emit($event); expandedSidenav=!expandedSidenav" [expandedSidenav]="expandedSidenav">
  <ng-container *ngIf="eflowEnabled || signaformEnabled || builderEnabled ||signEnabled">
    <adf-toolbar-divider></adf-toolbar-divider>

    <img *ngIf="actualUrl?.startsWith('/eflow/')" [alt]="'EFLOW.IMAGES.EFLOW' | translate"
      [src]="'assets/alden-eflow-extension/images/eflow-icon.svg'" style="width: 40px;" (click)="navigateTo('/eflow')">
    <img *ngIf="actualUrl?.startsWith('/signaform/')" [alt]="'SIGNAFORM.IMAGES.SIGNAFORM' | translate"
      [src]="'assets/alden-signaform-extension/images/signaform-icon.svg'" style="width: 40px;"
      (click)="navigateTo('/signaform')">
    <img *ngIf="actualUrl?.startsWith('/builder/')" [alt]="'BUILDER.IMAGES.BUILDER' | translate"
      [src]="'assets/alden-builder-extension/images/builder-icon.svg'" style="width: 40px;"
      (click)="navigateTo('/builder')">
    <img *ngIf="actualUrl?.startsWith('/sign/')" [alt]="'SIGN.IMAGES.SIGN' | translate"
      [src]="'assets/alden-sign-extension/images/firma.svg'" style="width: 40px;" (click)="navigateTo('/sign')">

    <button mat-icon-button class="widget-icon" [matMenuTriggerFor]="iconMenu" *ngIf="(eflowEnabled && !actualUrl?.startsWith('/eflow/')) 
      || (signaformEnabled && !actualUrl?.startsWith('/signaform/')) 
      || (builderEnabled && !actualUrl?.startsWith('/builder/'))
      || (signEnabled && !actualUrl?.startsWith('/sign/'))">
      <img *ngIf="widgetsImageIcon" [src]="'assets/alden-extension/images/ICONO_WIDGETS.svg'">
      <mat-icon *ngIf="!widgetsImageIcon" fontSet="material-icons-outlined">widgets</mat-icon>
    </button>

    <!-- Menú con iconos -->
    <mat-menu #iconMenu="matMenu">
      <button mat-menu-item *ngIf="signaformEnabled && !actualUrl?.startsWith('/signaform/')" class="plugin-icon"
        (click)="navigateTo('/signaform')">
        <img [alt]="'SIGNAFORM.IMAGES.SIGNAFORM' | translate"
          [src]="'assets/alden-signaform-extension/images/signaform-icon.svg'" style="width: 40px;">
        <span>Signaform</span>
      </button>
      <button mat-menu-item *ngIf="builderEnabled && !actualUrl?.startsWith('/builder/')" class="plugin-icon"
        (click)="navigateTo('/builder')">
        <img [alt]="'BUILDER.IMAGES.BUILDER' | translate"
          [src]="'assets/alden-builder-extension/images/builder-icon.svg'" style="width: 40px;">
        <span>{{ 'BUILDER.TITLE' | translate }}</span>
      </button>
      <button mat-menu-item *ngIf="eflowEnabled && !actualUrl?.startsWith('/eflow/')" class="plugin-icon"
        (click)="navigateTo('/eflow')">
        <img [alt]="'EFLOW.IMAGES.EFLOW' | translate" [src]="'assets/alden-eflow-extension/images/eflow-icon.svg'"
          style="width: 40px;">
        <span>{{ 'EFLOW.TITLE' | translate }}</span>
      </button>
      <button mat-menu-item *ngIf="signEnabled && !actualUrl?.startsWith('/sign/')" class="plugin-icon"
        (click)="navigateTo('/sign')">
        <img [alt]="'SIGN.IMAGES.SIGN' | translate" [src]="'assets/alden-sign-extension/images/firma.svg'"
          style="width: 40px;">
        <span>{{ 'SIGN.TITLE' | translate }}</span>
      </button>
    </mat-menu>
  </ng-container>

  <div class="adf-toolbar--spacer adf-toolbar-divider"></div>

  <ng-container *ngIf="showGlobalSearch && !isViewer">
    <alden-search-input *ngIf="contentServiceEnabled"></alden-search-input>
    <adf-toolbar-divider></adf-toolbar-divider>
  </ng-container>

  <ng-container *ngFor="let actionRef of actions; trackBy: trackByActionId">
    <aca-toolbar-action [actionRef]="actionRef"> </aca-toolbar-action>
  </ng-container>
</adf-layout-header>